import { House, SprayBottle, HandSoap, Plant, ArrowRight } from "@phosphor-icons/react";
import { useLenis } from "lenis/react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ICONS = { House, SprayBottle, HandSoap, Plant };

export default function PrivateServices() {
  const { t } = useLang();
  const lenis = useLenis();

  return (
    <section id="privati" data-testid="private-section" className="border-t border-champagne/20 bg-ivory py-20 md:py-28">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>{t.private.overline}</Overline>
            <h2 className="font-serif text-3xl font-light leading-[1.12] tracking-tight text-navy md:text-4xl">
              {t.private.title}
            </h2>
            <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-navy/65 md:text-base">
              {t.private.text}
            </p>
            <a
              href="#contatti"
              onClick={(e) => { e.preventDefault(); lenis?.scrollTo("#contatti", { offset: -64, duration: 1.4 }); }}
              data-testid="private-cta-link"
              className="group mt-8 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-champagne transition-colors duration-300 hover:text-navy"
            >
              {t.private.cta}
              <ArrowRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2">
            {(t.private.items || []).map((item, i) => {
              const Icon = ICONS[item.icon];
              return (
                <Reveal key={item.title} delay={i * 0.06}>
                  <div data-testid={`private-item-${i + 1}`} className="flex gap-5 border-b border-navy/10 py-7 pr-6 sm:odd:border-r sm:odd:pr-8 sm:even:pl-8">
                    <Icon size={26} weight="light" className="mt-1 shrink-0 text-champagne" />
                    <div>
                      <h3 className="font-serif text-xl font-light tracking-tight text-navy">{item.title}</h3>
                      <p className="mt-1.5 text-sm font-light leading-relaxed text-navy/60">{item.text}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
